import styled, { StyledProps } from 'styled-components'
import { EModBordered, IModBordered } from '@ucheba/utils/helpers/styles/mod.types'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

const Block = styled.tbody<StyledProps<IModBordered>>`
  ${sm.mod(EModBordered.false)`
    td {
      border-bottom: none;
    }
  `};
`

export default { Block }
